<div class="container mt-4">
  <h2>Create Role Group</h2>
  <form [formGroup]="roleGroupForm" (ngSubmit)="onSubmit()">
    <div class="mb-3">
      <label for="name" class="form-label">Name</label>
      <input id="name" type="text" class="form-control" formControlName="name" />
      <div *ngIf="roleGroupForm.get('name').invalid && roleGroupForm.get('name').touched" class="text-danger">
        Name is required and must be at least 3 characters long.
      </div>
    </div>

    <div class="mb-3">
      <label for="description" class="form-label">Description</label>
      <textarea id="description" class="form-control" formControlName="description"></textarea>
      <div *ngIf="roleGroupForm.get('description').invalid && roleGroupForm.get('description').touched" class="text-danger">
        Description is required and must be at least 5 characters long.
      </div>
    </div>

    <button type="submit" class="btn btn-primary" [disabled]="isSaving">Create</button>
    <div *ngIf="errorSaving" class="text-danger mt-2">Error saving Role Group. Please try again.</div>
  </form>
</div>
